import { useState } from 'react';
import { useParams } from 'react-router-dom';
import FormView from './FormView';
import PasswordSavedView from './PasswordSavedView';

const SetNewPassword = () => {
  const { token } = useParams();
  const [passwordAccepted, setPasswordAccepted] = useState(false);

  return (
    <div className='w-1/2'>
      {passwordAccepted ? <PasswordSavedView /> : <FormView token={token} setPasswordAccepted={setPasswordAccepted} />}
    </div>
  );
};

export default SetNewPassword;
